<template lang="pug">
  v-container#container.mt-2.pa-0(fluid)
    v-container#postal.pa-0(fluid justify-center)
      v-container.postal.px-0.mt-3.pb-0(fluid)
        v-layout.header.mr-0(row wrap)
          v-flex(d-flex xs12 sm4)
            v-layout(column)
              v-flex(d-flex xs1)
                v-card.pl-5.mt-2.justify-center.align-center(d-flex flat)
                  img.info(src="static/logoline.png")
          v-flex.pb-2(d-flex xs12 sm8)
            v-layout.pl-3(column)
              v-flex(d-flex xs12)
                v-card.pr-5(flat)
                  img.info(src="static/info.png")
              v-flex(d-flex xs12)
                v-card.fill.folio(flat v-bind:style="getColor")
                  v-flex(d-flex xs12 fill-height align-center)
                    v-card-text.py-0.px-3
                      h1.head.title Folio #[span(class="subtitle") {{identifier}} {{record.folio}}]
                    v-card-text.py-0.px-3
                      p.head.subtitle(fill-height align-center) {{record.state}}
        v-layout.px-3.pt-1.aggression(row wrap d-flex fill-height align-contentcenter)
          v-flex(d-flex xs4)
            v-card(flat)
              v-card-text.pb-0.pt-1
                p.info-title Tipo de agresión
          v-flex(d-flex xs8 align-center)
            v-divider
          v-flex(d-flex xs12).type
            v-layout(column)
              v-flex(d-flex)
                v-card.fill(flat v-bind:style="getColor")
                  v-card-text.py-2.text-xs-center
                    h1.title-large {{aggressionType}}
                    p.subtitle.mt-2 {{aggressionSubtype}}
        v-layout.px-3.where(row wrap)
          v-flex.border(d-flex xs12)
            v-card(flat).fill-height.align-center.d-flex
              v-card-text.pt-0.pb-0.px-3
                p.info-title Dónde
            v-card.fill(flat v-bind:style="getColor").fill-height.align-center.d-flex
              v-card-text.pt-1.pb-0.px-3
                h1.title {{record.state}}.
                  span.subtitle  {{record.municipality}}
        v-layout.px-3.when(row wrap)
          v-flex(d-flex xs12)
            v-card(flat).fill-height.align-center.d-flex
              v-card-text.pt-0.pb-1
                p.info-title Cuándo
            v-card(flat)
              v-card-text.subtitle.pt-0.pb-1 {{record["aggression_datetime"]}} hrs
        v-layout.px-3.verified(row wrap)
          v-flex.border(d-flex xs12)
            v-card(flat).fill-height.align-center.d-flex
              v-card-text.py-0.px-3
                p.info-title Verificada el
            v-card.fill(flat v-bind:style="getColor").fill-height.align-center.d-flex
              v-card-text.title.py-1.px-3 {{record["verification_datetime"]}} hrs
        v-layout.px-3.details(row wrap)
          v-flex.border(xs12)
            v-card(flat)
              v-card-text.pb-0.pt-1
                p.info-title Más información
          v-flex(xs12)
            v-card(flat)
              v-card-text.px-4.py-1
                p.text-xs-center {{record.details}}
      v-container.footer.pa-0
        img(src="static/Footer.png")
    Reviews(v-if="path !== '/form'")
</template>

<script>
import Reviews from "@/components/Reviews.vue";

export default {
  name: "Postal",
  props: {},
  components: {
    Reviews
  },
  data() {
    return {};
  },
  computed: {
    path() {
      return this.$router.currentRoute.path;
    },
    patchColors() {
      return this.$store.state.patchColors;
    },
    record() {
      let record = this.$store.getters.record;
      /*if (record.folio) {
        while (record.folio.length < 4) {
          const cero = "0";
          record.folio = cero.concat(record.folio);
        }
      }*/
      return record;
    },
    identifier() {
      return this.record.context ? this.record.context.contextId + "-" : "";
    },
    allContextsColors() {
      return this.$store.getters.contexts;
    },
    getColor() {
      if (!this.record.context) {
        /* console.log({ backgroundColor: "#dee2e6" }) */
        return { backgroundColor: "#dee2e6" };
      } else {
        const postalColor = this.allContextsColors.find(context => {
          return context.context === this.record.context.context;
        });
        /* const style = {
          backgroundColor: postalColor ? postalColor.color : "#dee2e6"
        }; */
        /* console.log(this.record.state)
        console.log(this.patchColors.filter(c => c.nom_ent === this.record.state)[0].color)
        console.log(style) */

        const style = {
          backgroundColor: this.patchColors.filter(c => c.nom_ent === this.record.state)[0] ? this.patchColors.filter(c => c.nom_ent === this.record.state)[0].color : (postalColor ? postalColor.color : "#dee2e6")
        };

        return style;
      }
    },
    aggressionType() {
      if (this.record["aggression_type"].length < 1) return undefined;
      else {
        const types = this.record["aggression_type"].join(", ");
        return types;
      }
    },
    aggressionSubtype() {
      if (this.record["aggression_subtype"].length < 1) return undefined;
      else {
        const types = this.record["aggression_subtype"].join(", ");
        return types;
      }
    }
  },
  mounted() {
    // console.log(this.stateColors)
    // console.log(this.record)
  }
};
</script>

<style src="./postal.scss" lang="scss">
</style>
